import { __APP_NAME__ } from "config/static";

export default function Footer() {
  return (
    <footer className="mt-auto w-full border-t border-gray-200 dark:border-white/5 bg-gray-100 dark:bg-gray-950 transition-colors">
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-2 text-gray-400">
          <span className="text-xs font-medium">© 2025</span>
          <span className="w-1 h-1 bg-gray-300 rounded-full" />
          <a
            href="/"
            className="text-sm font-bold text-gray-600 dark:text-gray-300 hover:text-mainLight transition-colors"
          >
            {__APP_NAME__}
          </a>
        </div>

        <div className="flex gap-6">
          <a
            href="#"
            className="text-[11px] font-bold text-gray-400 hover:text-mainLight uppercase tracking-widest"
          >
            Privacy Policy
          </a>
          <a
            href="#"
            className="text-[11px] font-bold text-gray-400 hover:text-mainLight uppercase tracking-widest"
          >
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
}
